import amplitude from "amplitude-js"
import { AmplitudeToken } from "../configs"

amplitude.getInstance().init(AmplitudeToken)

export const AmpJS = () => amplitude.getInstance()
